
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cart_45qAh4E3TJpchaOiVAsnQPk9vBJAEa_45nPIHWmRDaIYYQMeta } from "/app/services/upgrade/src/pages/cart.vue?macro=true";
import { default as indexSQgck9Z3cF_OtzUzPOCW4cD2JxoRuLggWe2PE28SRoEMeta } from "/app/services/upgrade/src/pages/index.vue?macro=true";
import { default as loginUUEXtvZ_45xJHUThu9biRJasgX23zEQddDVaCFEFVfDJYMeta } from "/app/services/upgrade/src/pages/login.vue?macro=true";
import { default as faqzVxgPaisAXt4SAQn_9dGiJcctHLV9OG7_45HFp_tF13MQMeta } from "/app/services/upgrade/src/pages/profile/faq.vue?macro=true";
import { default as indexdhA5dQfzDDDyGPndYVLyzr2cwq7MA_45TliWTSXN8Sn6sMeta } from "/app/services/upgrade/src/pages/profile/index.vue?macro=true";
import { default as my_45devicesiMOeytmsL_45Rg_45OCypAkBNw0JqjYVFf0qNHm0iyksNucMeta } from "/app/services/upgrade/src/pages/profile/my-devices.vue?macro=true";
import { default as new_45devicen0quC8olGZlyNywlg41zPBGf9OW08_wE6u1JlhbgCAQMeta } from "/app/services/upgrade/src/pages/profile/new-device.vue?macro=true";
import { default as applicationed151gadf6ioKd9L1Ic8iLStp9Dh0woSjynetCJebzIMeta } from "/app/services/upgrade/src/pages/profile/application.vue?macro=true";
import { default as personal_45infoC17MOPOHjl6lqrtaP1iVJgE3Bueqtbd7KYelKrKT3VcMeta } from "/app/services/upgrade/src/pages/profile/personal-info.vue?macro=true";
import { default as device_45for_45youQGx_458OcsXQCAYUiCtG9rfWX_45pQWQhPBtT9e2cTzWxLIMeta } from "/app/services/upgrade/src/pages/profile/device-for-you.vue?macro=true";
import { default as extended_45coverage59bwOa1tV2WUtO_45pyH5lAkwI0yZ9UVWg_wxEvxwN7jcMeta } from "/app/services/upgrade/src/pages/profile/extended-coverage.vue?macro=true";
import { default as reported_45problems1DKzsaJ1iUEg_45n5ARZWQvO7qudTb63uFBaqf81axyiYMeta } from "/app/services/upgrade/src/pages/profile/reported-problems.vue?macro=true";
import { default as _91id_938ba8dcHPjShzTbP1uIpkLkYZ1_45jXaz_455c8NerJREsvcMeta } from "/app/services/upgrade/src/pages/profile/problems-detail/[id].vue?macro=true";
import { default as profilessquwMYhlDQWVWKgGA1CA5Fuq2WZu7m9uxkAKfjdY8QMeta } from "/app/services/upgrade/src/pages/profile.vue?macro=true";
import { default as _91seo_name_937b9tM6wuOzK8xZHfyRIee7AA737vOzShuA_45fjSPTQ6cMeta } from "/app/services/upgrade/src/pages/[seo_name].vue?macro=true";
import { default as StyleGuide9m1IDZls42A_45xXvbgQvFh8e4mL_0ZicfaudPtIb09QMMeta } from "/app/services/upgrade/src/pages/StyleGuide.vue?macro=true";
import { default as indexldaF4tBb8tCV7T8Crxp2omHGYop5EpTmNprtrUzErswMeta } from "/app/services/upgrade/src/pages/stores/index.vue?macro=true";
import { default as business_45termsqSyH91Re1oLFm8QIhAsXxzVsgBHDLeee9ua7FkZuB8kMeta } from "/app/services/upgrade/src/pages/business-terms.vue?macro=true";
import { default as privacy_45policyMcVA2r8x2oI2kHG1SIPgIUZFU_WvEcmVEPMod_CqATcMeta } from "/app/services/upgrade/src/pages/privacy-policy.vue?macro=true";
import { default as complaints_45policy1eGBs6v_45BNrxd8bjbHvwYYJnvHAyCJffVgR554_z63QMeta } from "/app/services/upgrade/src/pages/complaints-policy.vue?macro=true";
import { default as _91seo_name_93My0YfR_45m6RF6gJZfSqDVBCFycATL5RdsF3vFtGCgAjMMeta } from "/app/services/upgrade/src/pages/stores/[seo_name].vue?macro=true";
import { default as _91seo_name_93Iv49j2OZyPU0m9GyTIHU2wXfrdLpMvxeBwzl0LUWIIUMeta } from "/app/services/upgrade/src/pages/[partner]/[seo_name].vue?macro=true";
import { default as business_45termsofFYGNl0vDRbDoyvxvXDi9puHKSdm52vjObtKLWDKGgMeta } from "/app/services/upgrade/src/pages/[partner]/business-terms.vue?macro=true";
import { default as privacy_45policyZA9T1G37uAny9k0cdYsZUipdrM0MoJUgBby_8tbh848Meta } from "/app/services/upgrade/src/pages/[partner]/privacy-policy.vue?macro=true";
import { default as _91_91device_type_93_93U5zcave1M1FR3aJ7TyIGDaUqUa94LlyWXL8zEZr7p00Meta } from "/app/services/upgrade/src/pages/catalogue/[[device_type]].vue?macro=true";
import { default as thank_45youbOjXyNNCN0qbp117o_459NLEctIXgi96az01IRHHizv_oMeta } from "/app/services/upgrade/src/pages/device-problems/thank-you.vue?macro=true";
import { default as complaints_45policylBDxDgOGRGq3x701YZj6CGEi67Pzkc3E8_45dYrWz_qZ8Meta } from "/app/services/upgrade/src/pages/[partner]/complaints-policy.vue?macro=true";
import { default as _91id_93Iuy9bOeoAaJJUWa8pMgA_pe9_I8YIJkP5lTA9gX3xr4Meta } from "/app/services/upgrade/src/pages/return-pages/rejection/[id].vue?macro=true";
import { default as _91id_93KGTMd0SIj14P_45_45mY5naanVbZUPFqvBuId4L7VI9RTWEMeta } from "/app/services/upgrade/src/pages/return-pages/signature/[id].vue?macro=true";
import { default as problem_45typerFkRpIwZQGWZCqYiIO_45Gjo_45_VmFoF4gXc_45ProiDGuewMeta } from "/app/services/upgrade/src/pages/device-problems/[id]/problem-type.vue?macro=true";
import { default as device_45deliveryWFY6uZCDr9EI6OoCfl8kyB81LIVKRrL60KTguxcZZcAMeta } from "/app/services/upgrade/src/pages/device-problems/[id]/device-delivery.vue?macro=true";
import { default as more_45information1q6znUyt5neFY54qWP_ASEoZ0o_45naMOW2zi_fzfPXtMMeta } from "/app/services/upgrade/src/pages/device-problems/[id]/more-information.vue?macro=true";
import { default as specific_45problem6f1nEFFmOJMKIYHDLy9CzD5eFangZmNwsqMoLXA57CAMeta } from "/app/services/upgrade/src/pages/device-problems/[id]/specific-problem.vue?macro=true";
import { default as component_45stubE7nK03ZDIcT8vsVB5Oi7pPs4__45zJu4AFwebajgHJjAEMeta } from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.32_db0@0.3.2_eslint@9.29.0_jiti@2.4_3e3f463021fd64430fb1090fdfb4ba99/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE7nK03ZDIcT8vsVB5Oi7pPs4__45zJu4AFwebajgHJjAE } from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.32_db0@0.3.2_eslint@9.29.0_jiti@2.4_3e3f463021fd64430fb1090fdfb4ba99/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "cart___cs",
    path: "/kosik",
    meta: cart_45qAh4E3TJpchaOiVAsnQPk9vBJAEa_45nPIHWmRDaIYYQMeta || {},
    component: () => import("/app/services/upgrade/src/pages/cart.vue")
  },
  {
    name: "index___cs",
    path: "/",
    meta: indexSQgck9Z3cF_OtzUzPOCW4cD2JxoRuLggWe2PE28SRoEMeta || {},
    component: () => import("/app/services/upgrade/src/pages/index.vue")
  },
  {
    name: "login___cs",
    path: "/prihlaseni",
    meta: loginUUEXtvZ_45xJHUThu9biRJasgX23zEQddDVaCFEFVfDJYMeta || {},
    component: () => import("/app/services/upgrade/src/pages/login.vue")
  },
  {
    name: profilessquwMYhlDQWVWKgGA1CA5Fuq2WZu7m9uxkAKfjdY8QMeta?.name,
    path: "/profil",
    meta: profilessquwMYhlDQWVWKgGA1CA5Fuq2WZu7m9uxkAKfjdY8QMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile.vue"),
    children: [
  {
    name: "profile-faq___cs",
    path: "faq",
    meta: faqzVxgPaisAXt4SAQn_9dGiJcctHLV9OG7_45HFp_tF13MQMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/faq.vue")
  },
  {
    name: "profile___cs",
    path: "",
    meta: indexdhA5dQfzDDDyGPndYVLyzr2cwq7MA_45TliWTSXN8Sn6sMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/index.vue")
  },
  {
    name: "profile-my-devices___cs",
    path: "moje-zarizeni",
    meta: my_45devicesiMOeytmsL_45Rg_45OCypAkBNw0JqjYVFf0qNHm0iyksNucMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/my-devices.vue")
  },
  {
    name: "profile-new-device___cs",
    path: "nove-zarizeni",
    meta: new_45devicen0quC8olGZlyNywlg41zPBGf9OW08_wE6u1JlhbgCAQMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/new-device.vue")
  },
  {
    name: "profile-application___cs",
    path: "aplikace",
    meta: applicationed151gadf6ioKd9L1Ic8iLStp9Dh0woSjynetCJebzIMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/application.vue")
  },
  {
    name: "profile-personal-info___cs",
    path: "osobni-udaje",
    meta: personal_45infoC17MOPOHjl6lqrtaP1iVJgE3Bueqtbd7KYelKrKT3VcMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/personal-info.vue")
  },
  {
    name: "profile-device-for-you___cs",
    path: "zarizeni-pro-vas",
    meta: device_45for_45youQGx_458OcsXQCAYUiCtG9rfWX_45pQWQhPBtT9e2cTzWxLIMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/device-for-you.vue")
  },
  {
    name: "profile-extended-coverage___cs",
    path: "rozsirene-kryti",
    meta: extended_45coverage59bwOa1tV2WUtO_45pyH5lAkwI0yZ9UVWg_wxEvxwN7jcMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/extended-coverage.vue")
  },
  {
    name: "profile-reported-problems___cs",
    path: "nahlasene-problemy",
    meta: reported_45problems1DKzsaJ1iUEg_45n5ARZWQvO7qudTb63uFBaqf81axyiYMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/reported-problems.vue")
  },
  {
    name: "profile-problems-detail-id___cs",
    path: "detail-problemu/:id()",
    meta: _91id_938ba8dcHPjShzTbP1uIpkLkYZ1_45jXaz_455c8NerJREsvcMeta || {},
    component: () => import("/app/services/upgrade/src/pages/profile/problems-detail/[id].vue")
  }
]
  },
  {
    name: "seo_name___cs",
    path: "/:seo_name()",
    meta: _91seo_name_937b9tM6wuOzK8xZHfyRIee7AA737vOzShuA_45fjSPTQ6cMeta || {},
    component: () => import("/app/services/upgrade/src/pages/[seo_name].vue")
  },
  {
    name: "StyleGuide___cs",
    path: "/styleguide",
    meta: StyleGuide9m1IDZls42A_45xXvbgQvFh8e4mL_0ZicfaudPtIb09QMMeta || {},
    component: () => import("/app/services/upgrade/src/pages/StyleGuide.vue")
  },
  {
    name: "stores___cs",
    path: "/prodejny",
    meta: indexldaF4tBb8tCV7T8Crxp2omHGYop5EpTmNprtrUzErswMeta || {},
    component: () => import("/app/services/upgrade/src/pages/stores/index.vue")
  },
  {
    name: "business-terms___cs",
    path: "/obchodni-podminky",
    meta: business_45termsqSyH91Re1oLFm8QIhAsXxzVsgBHDLeee9ua7FkZuB8kMeta || {},
    component: () => import("/app/services/upgrade/src/pages/business-terms.vue")
  },
  {
    name: "privacy-policy___cs",
    path: "/ochrana-osobnich-udaju",
    meta: privacy_45policyMcVA2r8x2oI2kHG1SIPgIUZFU_WvEcmVEPMod_CqATcMeta || {},
    component: () => import("/app/services/upgrade/src/pages/privacy-policy.vue")
  },
  {
    name: "complaints-policy___cs",
    path: "/reklamacni-rad",
    meta: complaints_45policy1eGBs6v_45BNrxd8bjbHvwYYJnvHAyCJffVgR554_z63QMeta || {},
    component: () => import("/app/services/upgrade/src/pages/complaints-policy.vue")
  },
  {
    name: "stores-seo_name___cs",
    path: "/prodejny/:seo_name()",
    meta: _91seo_name_93My0YfR_45m6RF6gJZfSqDVBCFycATL5RdsF3vFtGCgAjMMeta || {},
    component: () => import("/app/services/upgrade/src/pages/stores/[seo_name].vue")
  },
  {
    name: "partner-seo_name___cs",
    path: "/:partner()/:seo_name()",
    meta: _91seo_name_93Iv49j2OZyPU0m9GyTIHU2wXfrdLpMvxeBwzl0LUWIIUMeta || {},
    component: () => import("/app/services/upgrade/src/pages/[partner]/[seo_name].vue")
  },
  {
    name: "partner-business-terms___cs",
    path: "/:partner()/obchodni-podminky",
    meta: business_45termsofFYGNl0vDRbDoyvxvXDi9puHKSdm52vjObtKLWDKGgMeta || {},
    component: () => import("/app/services/upgrade/src/pages/[partner]/business-terms.vue")
  },
  {
    name: "partner-privacy-policy___cs",
    path: "/:partner()/ochrana-osobnich-udaju",
    meta: privacy_45policyZA9T1G37uAny9k0cdYsZUipdrM0MoJUgBby_8tbh848Meta || {},
    component: () => import("/app/services/upgrade/src/pages/[partner]/privacy-policy.vue")
  },
  {
    name: "catalogue-device_type___cs",
    path: "/katalog/:device_type?",
    meta: _91_91device_type_93_93U5zcave1M1FR3aJ7TyIGDaUqUa94LlyWXL8zEZr7p00Meta || {},
    component: () => import("/app/services/upgrade/src/pages/catalogue/[[device_type]].vue")
  },
  {
    name: "device-problems-thank-you___cs",
    path: "/zarizeni-problemy/dekujeme",
    component: () => import("/app/services/upgrade/src/pages/device-problems/thank-you.vue")
  },
  {
    name: "partner-complaints-policy___cs",
    path: "/:partner()/reklamacni-rad",
    meta: complaints_45policylBDxDgOGRGq3x701YZj6CGEi67Pzkc3E8_45dYrWz_qZ8Meta || {},
    component: () => import("/app/services/upgrade/src/pages/[partner]/complaints-policy.vue")
  },
  {
    name: "return-pages-rejection-id___cs",
    path: "/odmitnuti/:id()",
    meta: _91id_93Iuy9bOeoAaJJUWa8pMgA_pe9_I8YIJkP5lTA9gX3xr4Meta || {},
    component: () => import("/app/services/upgrade/src/pages/return-pages/rejection/[id].vue")
  },
  {
    name: "return-pages-signature-id___cs",
    path: "/podpis/:id()",
    meta: _91id_93KGTMd0SIj14P_45_45mY5naanVbZUPFqvBuId4L7VI9RTWEMeta || {},
    component: () => import("/app/services/upgrade/src/pages/return-pages/signature/[id].vue")
  },
  {
    name: "device-problems-id-problem-type___cs",
    path: "/zarizeni-problemy/:id()/typ-problemu",
    meta: problem_45typerFkRpIwZQGWZCqYiIO_45Gjo_45_VmFoF4gXc_45ProiDGuewMeta || {},
    component: () => import("/app/services/upgrade/src/pages/device-problems/[id]/problem-type.vue")
  },
  {
    name: "device-problems-id-device-delivery___cs",
    path: "/zarizeni-problemy/:id()/doruceni-zarizeni",
    component: () => import("/app/services/upgrade/src/pages/device-problems/[id]/device-delivery.vue")
  },
  {
    name: "device-problems-id-more-information___cs",
    path: "/zarizeni-problemy/:id()/vice-informaci",
    meta: more_45information1q6znUyt5neFY54qWP_ASEoZ0o_45naMOW2zi_fzfPXtMMeta || {},
    component: () => import("/app/services/upgrade/src/pages/device-problems/[id]/more-information.vue")
  },
  {
    name: "device-problems-id-specific-problem___cs",
    path: "/zarizeni-problemy/:id()/konkretni-problem",
    meta: specific_45problem6f1nEFFmOJMKIYHDLy9CzD5eFangZmNwsqMoLXA57CAMeta || {},
    component: () => import("/app/services/upgrade/src/pages/device-problems/[id]/specific-problem.vue")
  },
  {
    name: component_45stubE7nK03ZDIcT8vsVB5Oi7pPs4__45zJu4AFwebajgHJjAEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubE7nK03ZDIcT8vsVB5Oi7pPs4__45zJu4AFwebajgHJjAE
  }
]